"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var react_1 = __importStar(require("react"));
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var styles_1 = require("@mui/material/styles");
var react_admin_1 = require("react-admin");
var material_1 = require("@mui/material");
var q_play_components_1 = require("@nordicscreen/q-play-components");
var Accordion_1 = __importDefault(require("../common/Accordion"));
var Presentations_module_css_1 = __importDefault(require("./Presentations.module.css"));
var react_i18next_1 = require("react-i18next");
var useRoute_1 = __importDefault(require("@/Hooks/useRoute"));
var RAStyles_1 = require("../common/ReactAdmin/RAStyles");
var ApiManager_1 = __importDefault(require("@/functions/ApiManager"));
var types_1 = require("@/Types/types");
var react_dnd_1 = require("react-dnd");
var react_dnd_html5_backend_1 = require("react-dnd-html5-backend");
var q_play_core_1 = require("@nordicscreen/q-play-core");
var TextFieldWithTranslation_1 = __importDefault(require("../common/ReactAdmin/TextFieldWithTranslation"));
var ResourceAccessModal_1 = __importDefault(require("../common/ResourceAccessModal"));
var MeatballMenu_1 = __importDefault(require("../common/MeatballMenu"));
var types_2 = require("@/Types/types");
var AccessControl_1 = __importDefault(require("../common/AccessControl"));
var ResourceDeleteErrorModal_1 = __importDefault(require("../common/ResourceDeleteErrorModal"));
var imageErrorCache_1 = require("@/functions/imageErrorCache");
var ImageFieldWithPlaceholder = react_1.default.memo(function (_a) {
    var source = _a.source;
    var record = (0, react_admin_1.useRecordContext)();
    var _b = (0, react_1.useState)(!imageErrorCache_1.failedImageUrls.has(record[source])), isLoading = _b[0], setIsLoading = _b[1];
    var _c = (0, react_1.useState)(imageErrorCache_1.failedImageUrls.has(record[source])), isError = _c[0], setIsError = _c[1];
    var src = record[source];
    var handleLoad = function () {
        setIsLoading(false);
    };
    var handleError = function () {
        setIsError(true);
        setIsLoading(false);
        imageErrorCache_1.failedImageUrls.add(src);
    };
    (0, react_1.useEffect)(function () {
        if (imageErrorCache_1.failedImageUrls.has(src)) {
            setIsError(true);
            setIsLoading(false);
        }
        else {
            setIsError(false);
            setIsLoading(true);
        }
    }, [src]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        isLoading && !isError && react_1.default.createElement(q_play_components_1.Spinner, null),
        isError && (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faImageLandscape, style: { fontSize: "36px", color: "var(--lightgray-color)" } })),
        !isError && (react_1.default.createElement("img", { src: src, onLoad: handleLoad, onError: handleError, className: Presentations_module_css_1.default.thumb_image, alt: record["title"] || "Presentation Thumbnail" }))));
});
ImageFieldWithPlaceholder.displayName = "ImageFieldWithPlaceholder";
var ColoredStatusField = function (props) {
    var record = (0, react_admin_1.useRecordContext)();
    return (react_1.default.createElement(TextFieldWithTranslation_1.default, { source: "state", sx: {
            backgroundColor: record.state === types_1.PresentationState.DRAFT ? "var(--warning-color)" : "var(--primary-color)",
            fontSize: "10px",
            fontFamily: "Geomanist-Bold",
        }, className: Presentations_module_css_1.default.presentation_status_grid_container, t: props.t }));
};
var PresentationCard = function (props) {
    var resource = (0, react_admin_1.useRecordContext)();
    var refresh = (0, react_admin_1.useRefresh)();
    var logger = q_play_core_1.logManager.getLogger();
    var route = (0, useRoute_1.default)();
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _a = (0, react_1.useState)(false), isHovered = _a[0], setIsHovered = _a[1];
    var permissions = props.permissions;
    var onClone = function (presentationId, resourceType) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ApiManager_1.default.clonePresentations(presentationId, resourceType).then(function () {
                        refresh();
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var savePresentationGroup = function (presentationGroup) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, ApiManager_1.default.updatePresentationGroup(resource, presentationGroup.id).then(function () { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        refresh();
                                        return [4 /*yield*/, props.fetchGroupHasPresentationFlags()];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    logger.error(error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var _b = (0, react_dnd_1.useDrag)(function () {
        return {
            type: "presentation",
            end: function (_item, monitor) { return __awaiter(void 0, void 0, void 0, function () {
                var dropResult;
                return __generator(this, function (_a) {
                    dropResult = monitor.getDropResult();
                    savePresentationGroup(dropResult);
                    return [2 /*return*/];
                });
            }); },
            collect: function (monitor) { return ({
                opacity: monitor.isDragging() ? 0.5 : 1,
            }); },
        };
    }, []), opacity = _b[0].opacity, dragRef = _b[1];
    var handleManageResourceAccess = function () {
        props.openPermissionModal(resource.presentation_id, resource.title, "Resource");
    };
    var handleManageGroupAccess = function () {
        var _a;
        props.openPermissionModal(Number(props.groupId), ((_a = resource.presentation_group) === null || _a === void 0 ? void 0 : _a.name) || "", "Group");
    };
    return (resource.presentation_group_id === props.groupId && (react_1.default.createElement(AccessControl_1.default, { resourceId: resource.presentation_id, resourceType: "".concat(props.resourceType.toLowerCase(), "s"), conditionalChildren: [
            {
                permission: __spreadArray(__spreadArray([], permissions.write, true), permissions.manage, true),
                children: (react_1.default.createElement(styles_1.ThemeProvider, { theme: RAStyles_1.RaPaperTheme },
                    react_1.default.createElement("div", { onMouseEnter: function () { return setIsHovered(true); }, onMouseLeave: function () { return setIsHovered(false); } },
                        react_1.default.createElement("div", { ref: dragRef, style: { opacity: opacity } },
                            react_1.default.createElement(material_1.Paper, { ref: dragRef, style: { opacity: opacity }, variant: "outlined", square: true, className: Presentations_module_css_1.default.mui_paper, "data-cy": "presentationCard", onClick: function () {
                                    window.location.href = route("editor/".concat(props.resourceType.toLowerCase()), { presentationId: resource.presentation_id });
                                } },
                                react_1.default.createElement("div", { className: "d-flex align-items-center justify-content-between", style: { height: "45px", whiteSpace: "nowrap" } },
                                    react_1.default.createElement(react_admin_1.TextField, { source: "title", sortable: false, "data-cy": "presentationCardName", title: resource.title }),
                                    react_1.default.createElement(ImageFieldWithPlaceholder, { source: "thumbnail_url" })),
                                react_1.default.createElement(ColoredStatusField, { t: t }),
                                react_1.default.createElement(q_play_components_1.Button, { text: t("Edit"), size: "small", variant: "primary", style: { width: "67px", height: "25px", marginTop: "18px" }, className: "d-flex justify-content-center align-items-center" }),
                                react_1.default.createElement(AccessControl_1.default, { resourceType: "".concat(props.resourceType.toLowerCase(), "s"), optionalPermissions: __spreadArray(__spreadArray(__spreadArray([], permissions.write, true), permissions.manage, true), ["edit-user-management"], false) },
                                    react_1.default.createElement(MeatballMenu_1.default, { onEdit: function () {
                                            window.location.href = route("editor/".concat(props.resourceType.toLowerCase()), { presentationId: resource.presentation_id });
                                        }, onManageResourceAccess: handleManageResourceAccess, onManageGroupAccess: handleManageGroupAccess, onDuplicate: function () { return onClone(resource.presentation_id, props.resourceType); }, onDelete: function () { return props.onDelete(resource.presentation_id); }, style: {
                                            position: "relative",
                                            bottom: "130px",
                                            left: "205px",
                                            display: isHovered ? "inline-block" : "none",
                                        }, menuSx: { marginLeft: "25px", marginBottom: "200px" }, resourceId: resource.presentation_id, resourceType: props.resourceType })))))))
            },
            {
                permission: permissions.read,
                children: (react_1.default.createElement(styles_1.ThemeProvider, { theme: RAStyles_1.RaPaperTheme },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("div", { style: { opacity: opacity } },
                            react_1.default.createElement(material_1.Paper, { style: { opacity: opacity }, variant: "outlined", square: true, className: Presentations_module_css_1.default.mui_paper, "data-cy": "presentationCard" },
                                react_1.default.createElement("div", { className: "d-flex align-items-center justify-content-between", style: { height: "45px", whiteSpace: "nowrap" } },
                                    react_1.default.createElement(react_admin_1.TextField, { source: "title", sortable: false, "data-cy": "presentationCardName", title: resource.title }),
                                    react_1.default.createElement(ImageFieldWithPlaceholder, { source: "thumbnail_url" })),
                                react_1.default.createElement(ColoredStatusField, { t: t }))))))
            }
        ] })));
};
var DroppableArea = function (_a) {
    var children = _a.children, groupId = _a.groupId;
    var _b = (0, react_dnd_1.useDrop)({
        accept: "presentation",
        drop: function () { return ({ id: groupId }); },
    }), drop = _b[1];
    return react_1.default.createElement("div", { ref: drop }, children);
};
var PresentationsGridView = function (_a) {
    var presentationType = _a.presentationType, presentationGroups = _a.presentationGroups, handleGroupDeletion = _a.handleGroupDeletion, refreshPresentationGroups = _a.refreshPresentationGroups, permissions = _a.permissions, groupHasPresentations = _a.groupHasPresentations, fetchGroupHasPresentationFlags = _a.fetchGroupHasPresentationFlags;
    var refresh = (0, react_admin_1.useRefresh)();
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var logger = q_play_core_1.logManager.getLogger();
    var _b = (0, react_1.useState)(-1), selectedPresentationId = _b[0], setSelectedPresentationId = _b[1];
    var _c = (0, react_1.useState)({ msg: "", players_and_presentation_details: [] }), deletePresentationErrorModalData = _c[0], setDeletePresentationErrorModalData = _c[1];
    var _d = (0, react_1.useState)(false), presentationDetachingError = _d[0], setPresentationDetachingError = _d[1];
    var _e = (0, react_1.useState)(false), isDeletePresentationErrorModalShown = _e[0], setDeletePresentationErrorModalShown = _e[1];
    var _f = (0, react_1.useState)(false), resourceAccessModalShown = _f[0], setResourceAccessModalShown = _f[1];
    var _g = (0, react_1.useState)(null), currentGroupId = _g[0], setCurrentGroupId = _g[1];
    var _h = (0, react_1.useState)(""), resourceName = _h[0], setResourceName = _h[1];
    var _j = (0, react_1.useState)(null), currentResourceId = _j[0], setCurrentResourceId = _j[1];
    var _k = (0, react_1.useState)("Group"), currentType = _k[0], setCurrentType = _k[1];
    var onDelete = function (presentationId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSelectedPresentationId(presentationId);
                    return [4 /*yield*/, ApiManager_1.default.deletePresentations(presentationId)
                            .then(function (res) { return __awaiter(void 0, void 0, void 0, function () {
                            var errorData;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (res.data.error) {
                                            errorData = { msg: res.data.error };
                                            setDeletePresentationErrorModalShown(true);
                                            if (res.data.data.players_and_presentation_details) {
                                                errorData.players_and_presentation_details = res.data.data.players_and_presentation_details.map(function (detail) {
                                                    if (!detail.resource_type) {
                                                        detail.resource_type = types_2.ResourceType.PRESENTATION;
                                                    }
                                                    return detail;
                                                });
                                            }
                                            setDeletePresentationErrorModalData(errorData);
                                        }
                                        else {
                                            setDeletePresentationErrorModalShown(false);
                                        }
                                        refresh();
                                        return [4 /*yield*/, fetchGroupHasPresentationFlags()];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); })
                            .catch(function (error) {
                            logger.error("Failed to delete presentation", error);
                        })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var detachPresentationFromPlayer = function (playerId, presentationVersionId) {
        var response = ApiManager_1.default.deletePlayerPresentation(presentationVersionId, playerId);
        response.then(function () {
            setDeletePresentationErrorModalData(function (data) {
                var _a;
                return {
                    msg: data.msg,
                    players_and_presentation_details: ((_a = data.players_and_presentation_details) === null || _a === void 0 ? void 0 : _a.filter(function (d) { return d.primary_resource_id !== playerId; })) || []
                };
            });
            setPresentationDetachingError(false);
        }).catch(function () {
            setPresentationDetachingError(true);
        });
    };
    var closeResourceAccessModal = function () { return setResourceAccessModalShown(false); };
    var openResourceAccessModal = function (id, name, type) {
        var _a;
        if (type === "Group") {
            setCurrentGroupId(id);
            var groupName = (_a = presentationGroups.find(function (group) { return group.id === id; })) === null || _a === void 0 ? void 0 : _a.name;
            setResourceName(groupName || "");
            setCurrentType("Group");
        }
        else if (type === "Resource") {
            setCurrentResourceId(id);
            setResourceName(name);
            setCurrentType("Resource");
        }
        setResourceAccessModalShown(true);
    };
    var PresentationsGridContent = function (_a) {
        var presentationGroups = _a.presentationGroups, presentationType = _a.presentationType, permissions = _a.permissions, onDelete = _a.onDelete, openResourceAccessModal = _a.openResourceAccessModal, handleGroupDeletion = _a.handleGroupDeletion, refreshPresentationGroups = _a.refreshPresentationGroups;
        var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
        var filters = [react_1.default.createElement(react_admin_1.SearchInput, { source: "title", alwaysOn: true, key: "queryFilter", "data-cy": "presentationGridViewSearch", placeholder: t("Search") })];
        var logger = q_play_core_1.logManager.getLogger();
        var onGroupDelete = function (presentationGroupId) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ApiManager_1.default.deletePresentationGroups(presentationGroupId)
                            .then(function () {
                            handleGroupDeletion(presentationGroups.filter(function (group) { return group.id !== presentationGroupId; }));
                        })
                            .catch(function (error) { return logger.error(error); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        var updatePresentationGroupName = function (presentationGroupId, groupName, type) {
            var trimmedNewName = groupName.trim();
            var currentGroup = presentationGroups.find(function (group) { return group.id === presentationGroupId; });
            if (!trimmedNewName || trimmedNewName === (currentGroup === null || currentGroup === void 0 ? void 0 : currentGroup.name)) {
                return;
            }
            ApiManager_1.default.updatePresentationGroupName(presentationGroupId, groupName, type)
                .then(function () {
                refreshPresentationGroups();
            })
                .catch(function (error) {
                logger.error("Failed to update presentation group name:", error);
            });
        };
        var mapPresentationTypeToResourceType = function (presentationType) {
            switch (presentationType) {
                case types_1.PresentationType.PRESENTATION:
                    return types_2.ResourceType.PRESENTATION;
                case types_1.PresentationType.PLAYLIST:
                    return types_2.ResourceType.PLAYLIST;
                default:
                    throw new Error("Invalid PresentationType for ResourceType");
            }
        };
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: Presentations_module_css_1.default.searchbar_container },
                react_1.default.createElement(styles_1.ThemeProvider, { theme: RAStyles_1.RaSearchInputTheme },
                    react_1.default.createElement(react_admin_1.FilterForm, { filters: filters })),
                react_1.default.createElement(q_play_components_1.Button, { variant: "empty", size: "small", className: "".concat(Presentations_module_css_1.default.filter_button, " d-flex align-items-center justify-content-center") },
                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faBarsFilter, style: { fontSize: "28px" }, color: "var(--info-color)" }))),
            react_1.default.createElement("div", { style: { position: "relative", top: "-65px" } }, presentationGroups.map(function (presentationGroup) {
                var _a;
                var presentationGroupId = presentationGroup.id;
                return (react_1.default.createElement(react_dnd_1.DndProvider, { backend: react_dnd_html5_backend_1.HTML5Backend, key: presentationGroupId },
                    react_1.default.createElement(DroppableArea, { groupId: presentationGroupId },
                        react_1.default.createElement(Accordion_1.default, { defaultActiveKey: "0", onTrashClick: function () { return onGroupDelete(presentationGroupId); }, isDisabled: (_a = groupHasPresentations[presentationGroup.id]) !== null && _a !== void 0 ? _a : true, isLast: presentationGroups.length === 1, type: mapPresentationTypeToResourceType(presentationType), permissions: permissions, id: presentationGroupId, name: presentationGroup.name, onSave: function (id, newName) { return updatePresentationGroupName(id, newName, presentationType); }, onResourceAccessModalClick: function (groupId) { return openResourceAccessModal(groupId, presentationGroup.name, "Group"); } },
                            react_1.default.createElement(react_admin_1.SingleFieldList, { linkType: false },
                                react_1.default.createElement(PresentationCard, { groupId: presentationGroupId, resourceType: mapPresentationTypeToResourceType(presentationType), onDelete: onDelete, openPermissionModal: openResourceAccessModal, permissions: permissions, fetchGroupHasPresentationFlags: fetchGroupHasPresentationFlags }))))));
            }))));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_admin_1.InfiniteList, { exporter: false, sx: {
                "& .RaList-content": {
                    backgroundColor: "transparent",
                    boxShadow: "none",
                },
            }, queryOptions: {
                refetchOnWindowFocus: false,
                refetchOnReconnect: false,
                refetchOnMount: true,
                refetchInterval: 1000 * 60,
            } },
            react_1.default.createElement(PresentationsGridContent, { presentationGroups: presentationGroups, presentationType: presentationType, handleGroupDeletion: handleGroupDeletion, refreshPresentationGroups: refreshPresentationGroups, permissions: permissions, onDelete: onDelete, openResourceAccessModal: openResourceAccessModal })),
        react_1.default.createElement(ResourceDeleteErrorModal_1.default, { dataCy: "deletePresentationErrorModal", headerText: t("Unsuccessful deletion of presentation"), isShown: isDeletePresentationErrorModalShown, onClose: function () {
                setDeletePresentationErrorModalData({ msg: "", players_and_presentation_details: [] });
                setDeletePresentationErrorModalShown(function (state) { return !state; });
                setPresentationDetachingError(false);
            }, deleteResourceMethod: onDelete, detachResourceMethod: detachPresentationFromPlayer, resourceId: selectedPresentationId, message: deletePresentationErrorModalData.msg, data: deletePresentationErrorModalData.players_and_presentation_details, resourceDetachError: presentationDetachingError, subTitleText: t("Deleting presentation was unsuccessful"), resourceAttachedToText: t("The presentation is attached to players"), tooltipText: function (resourceType) { return t("Detach ".concat(resourceType.toLowerCase(), " from this player")); }, detachErrorTest: t("Error detaching presentation") }),
        react_1.default.createElement(ResourceAccessModal_1.default, { isShown: resourceAccessModalShown, onClose: closeResourceAccessModal, resourceType: types_2.ResourceType[presentationType], type: currentType, resourceName: resourceName, groupId: currentGroupId, resourceId: currentResourceId })));
};
exports.default = PresentationsGridView;
